import { createSlice, SliceCaseReducers } from '@reduxjs/toolkit';
import { getInitialAppReduxState } from '.';
import { IBillReduxState } from '../models';

const billSlice = createSlice<IBillReduxState, SliceCaseReducers<IBillReduxState>>({
  name: 'bill',
  initialState: getInitialAppReduxState().bill,
  reducers: {
    updateEstimations: (state, action) => {
      const estimations = {
        ...state.estimations,
        [action.payload.selectedMeterId]: action.payload.estimations,
      };
      return { ...state, estimations };
    },
    reset: () => getInitialAppReduxState().bill,
  },
});

export const {
  updateEstimations, reset,
} = billSlice.actions;
export default billSlice.reducer;
